<template>
  <div class="previewLib h-full">
    <div class="left-block">
      <header>
        <div class="left">
          <el-tooltip class="item" effect="light" :content="templateDetail.templateTitle" placement="bottom">
            <h3>{{ templateDetail.templateTitle }}</h3>
          </el-tooltip>
          <label
            >被使用<i>{{ templateDetail.useNumber || 0 }}</i
            >次</label
          >
        </div>
        <div class="middle">
          <div @click="selectComputer">
            <img
              :src="
                selectedChange == 'computer-module'
                  ? '/entrance/img/template-library/computer-active.png'
                  : '/entrance/img/template-library/computer.png'
              "
            />
            <span :class="selectedChange == 'computer-module' ? 'active' : ''">电脑</span>
          </div>
          <div @click="selectPhone">
            <img
              :src="
                selectedChange == 'phone-module'
                  ? '/entrance/img/template-library/phone-active.png'
                  : '/entrance/img/template-library/phone.png'
              "
            />
            <span :class="selectedChange == 'phone-module' ? 'active' : ''">手机</span>
          </div>
        </div>
        <div class="right" @click="debounceCreate(id)">使用此模版</div>
      </header>
      <article style="height: calc(100% - 30px);" class="overflow-auto">
        <keep-alive>
          <component :is="selectedChange" :surveyId="id"></component>
        </keep-alive>
      </article>
    </div>
    <div class="right-block">
      <h3>相关模版</h3>
      <div v-if="templateList.length" class="content" v-loading="temLoading">
        <div class="item-box" @click="viewTemplate(item)" v-for="(item, index) in templateList" :key="index">
          <div class="img-box">
            <el-image :src="getUrl(item.cover || item.defaultCover)" class="w-full">
              <div slot="error" class="image-slot w-full text-center mt-20 text-3xl text-gray-500">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="info">
            <p>{{ item.templateTitle }}</p>
          </div>
        </div>
      </div>
      <div v-if="!templateList.length && !temLoading" class="text-center pt-20">暂无相关模版</div>
    </div>
  </div>
</template>

<script>
import PhoneModule from './components/PhoneModule'
import ComputerModule from './components/ComputerModule'
import { getRelatedTemplates, addUseById, copyTemplate, getTemplateById } from '@/api/wenjuan/template-library.js'
import { SurveyScene } from '@/assets/js/config/survey-config.js'

export default {
  name: 'previewLib',
  components: { PhoneModule, ComputerModule },
  props: {},
  data() {
    return {
      selectedChange: 'computer-module',
      templateList: [],
      temLoading: false,
      s_id: this.$route.query.surveyId,
      templateDetail: {},
      timer: null
    }
  },
  watch: {},
  computed: {
    id: {
      get() {
        return this.s_id
      },
      set(v) {
        this.s_id = v
      }
    },
    getParams() {
      return {
        templateId: this.id,
        industryTypeCode: this.templateDetail.industryTypeCode, //行业分类标签
        sceneTypeCode: this.templateDetail.sceneTypeCode //场景分类标签
      }
    },
    getUrl() {
      return function (url) {
        let baseUrl = window.location.origin
        return baseUrl + '/fill/api/v1/download?fileName=' + url
      }
    }
  },
  methods: {
    viewTemplate(item) {
      this.id = item.surveyId
      this.getDetail()
    },
    //获取相关模版列表
    getRelatedTemplates() {
      this.temLoading = true
      getRelatedTemplates(this.getParams).then(res => {
        if (res.data.code != 0) {
          return
        }
        this.templateList = res.data.data.slice(0, 4)
        this.temLoading = false
      })
    },
    selectPhone() {
      this.selectedChange = 'phone-module'
    },
    selectComputer() {
      this.selectedChange = 'computer-module'
    },
    debounceCreate(surveyId) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.toEditWj(surveyId)
      }, 500)
    },
    toEditWj(surveyId) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      copyTemplate(surveyId, { type: 4, groupId: '' })
        .then(res => {
          if (res.data.code != 0) {
            this.$message.warning(res.data.msg)
            return
          }
          let newSurveyId = res.data.data
          addUseById({ 
            surveyId,
            sceneType: this.$route.query.scene ? SurveyScene[this.$route.query.scene] : ''
           }).then(res => {})
          this.$router.push({
            path: `/survey/${newSurveyId}/edit?scene=${this.$route.query.scene ? this.$route.query.scene: 'Default'}`
          })
        })
        .catch(err => {
          this.$message.error('使用失败，稍后重试')
        })
        .finally(() => {
          loading.close()
        })
    },
    async getDetail() {
      let res = await getTemplateById(this.id)
      this.templateDetail = res.data.data
      await this.getRelatedTemplates()
    }
  },
  created() {
    this.getDetail()
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.previewLib {
  display: flex;
  .left-block {
    width: 83%;
    padding: 17px 32px;
    @apply bg-theme-gray flex flex-col;
    header {
      height: 30px;
      @apply flex justify-between relative;
      .left {
        width: calc(50% - 84px);
        h3 {
          color: rgba($color: #000000, $alpha: 0.85);
          max-width: 380px;
          @apply font-medium text-20 inline-block overflow-hidden overflow-ellipsis whitespace-nowrap align-middle w-3/4;
        }
        label {
          color: rgba(108, 116, 138, 0.65);
          @apply font-normal text-small inline-block ml-2 align-middle;
          i {
            font-style: initial;
            color: rgba($color: #000000, $alpha: 0.65);
            margin: 0 4px;
            @apply font-semibold;
          }
        }
      }
      .middle {
        @apply absolute left-1/2 flex transform -translate-x-1/2;
        .active {
          @apply text-theme;
        }
        div {
          img {
            @apply w-6 h-6 align-middle cursor-pointer;
          }
          span {
            color: #6c748a;
            @apply font-normal text-medium ml-2 align-middle cursor-pointer;
          }
        }
        div:last-child {
          margin-left: 49px;
        }
      }
      .right {
        width: 102px;
        height: 30px;
        line-height: 30px;
        @apply bg-theme rounded-small font-normal text-medium text-white text-center cursor-pointer;
      }
    }
    article {
      flex: 1;
      // .content{
      //   width: 442px;
      //   height: 738px;
      //   margin: 0 auto;
      //   /* transform: translateY(-94px); */
      //   background-image: url(/entrance/img/template-library/iPhoneXWhite.png);
      //   background-size: 100% 100%;
      //   position: relative;
      //   border: 1px solid transparent;
      //   box-sizing: border-box;
      //   .iframe-box{
      //     width: 287px;
      //     height: 604px;
      //     margin-left: 77px;
      //     margin-top: 59px;
      //     background: #fff;
      //     border-radius: 34px;
      //     overflow: hidden;
      //     position: relative;
      //     img{
      //       position: absolute;
      //       top: 0px;
      //       left: 50%;
      //       transform: translateX(-50%);
      //       width: 154.5px;
      //     }
      //   }
      //   .code-box{
      //     width: 100px;
      //     height: 233px;
      //     padding: 18px 16px 16px 16px;
      //     background: #FFFFFF;
      //     box-shadow: 0 6px 10px 0 rgba(0,0,0,0.08);
      //     border-radius: 4px;
      //     position: absolute;
      //     text-align: center;
      //     right: -97px;
      //     top: 80px;
      //     .r{
      //       height: 16px;
      //       line-height: 16px;
      //     }
      //     span,img{
      //       display: inline-block;
      //       box-sizing: border-box;
      //       vertical-align: middle;
      //     }
      //     .r:first-child{
      //       img:first-child{
      //         width: 16px;
      //         height: 15.56px;
      //         opacity: 0.85;
      //       }
      //       span:nth-child(2){
      //         font-family: PingFangSC-Regular;
      //         font-weight: Regular;
      //         font-size: 14px;
      //         color: rgba($color: #000000, $alpha: 0.85);
      //         margin-left: 6px;
      //       }
      //     }
      //     p{
      //       font-family: PingFangSC-Regular;
      //       font-weight: Regular;
      //       font-size: 12px;
      //       color: rgba($color: #000000, $alpha: 0.45);
      //       margin-top: 8px;
      //     }
      //     .code-img-box{
      //       width: 100px;
      //       height: 100px;
      //       background: #ccc;
      //       margin-top: 16px;
      //       img{
      //         width: 100%;
      //       }
      //     }
      //     /deep/.el-divider--horizontal {
      //       margin: 15px 0 8px 0 !important;
      //     }
      //     .r:last-child{
      //       margin-top: 8px;
      //       cursor: pointer;
      //       img:first-child{
      //         width: 16px;
      //         height: 16px;
      //       }
      //       span:last-child{
      //         font-family: PingFangSC-Regular;
      //         font-weight: Regular;
      //         font-size: 12px;
      //         color: #2775E8;
      //         margin-left: 4px;
      //       }
      //     }
      //   }
      // }
    }
  }
  .right-block {
    width: 17%;
    @apply bg-white h-full;
    h3 {
      color: rgba($color: #000000, $alpha: 0.85);
      margin: 16px auto 8px 24px;
      @apply font-normal text-medium;
    }
    .content {
      height: calc(100% - 38px);
      padding: 0 24px;
      overflow: auto;
      .item-box {
        width: 187px;
        height: 248px;
        box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.08);
        @apply bg-white overflow-hidden mb-4 cursor-pointer;
        .img-box {
          width: 187px;
          height: 200px;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .info {
          padding: 8px 12px;
          p {
            font-family: PingFangSC-Regular;
            color: rgba($color: #000000, $alpha: 0.85);
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-word;
            @apply font-normal text-small;
          }
        }
      }
    }
  }
}
</style>
